import { render, staticRenderFns } from "./SidebarNavLinkIS.vue?vue&type=template&id=de7f7bd2"
import script from "./SidebarNavLinkIS.vue?vue&type=script&lang=js"
export * from "./SidebarNavLinkIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports